export const GuideStepEnum = {
    INACTIVE: 0,
    START: 1,
    LOGIN_WARNING: 2,
    SPELER: 3,
    DOEL_SCORE: 4,
    LEVEL: 5,
    INFO: 6,
    OUT_OF_BOUNDS: 7,

    // enum functions
    checkOOB(val, firstStep = GuideStepEnum.START) {
        if (val < GuideStepEnum.INACTIVE) {
            return GuideStepEnum.OUT_OF_BOUNDS - 1;
        }
        if (val >= GuideStepEnum.OUT_OF_BOUNDS) {
            return firstStep;
        }
        return val;
    }
};

export const SideBarItems = {
    NONE: 0,
    ACTIVE: 1,
    BLOK_EDITOR: 2,
    ACTION_REACTION: 3,
    BLOK_CHANGE_STATE: 4,
    BACKGROUND_COLOR: 5,
    BACKGROUND_DRAW: 6,
    BACKGROUND_ERASE: 7
};

export const BlokTypes = {};

export const LevelEditorModeEnum = {
    DEFAULT: 0,
    MOVE: 1,
    BACKGROUND: 2
};

export const BlockAppearanceTypes = {
    TEXTURE: 0,
    TEXT: 1
};

export const GuidePublishState = {
    NONE: 0,
    TITLE: 1 << 0,
    DESC: 1 << 1,
    LEVELS: 1 << 2,
    THUMBNAIL: 1 << 3,
    SUCCESS: 1 << 4
};
